export class PageZoom {
  constructor (zoomWrapper, container, options) {
    this.container = container
    this.zoomWrapper = zoomWrapper
    this.contentContainer = options.contentContainer
    this.minScale = this._toFixedNumber(options.minScale, 8)
    this.maxScale = options.maxScale
    this.pageThumbnail1 = options.pageThumbnail1
    this.pageThumbnail2 = options.pageThumbnail2
    this.zoomWithThumbnails = options.zoomWithThumbnails === undefined ? false : options.zoomWithThumbnails
    this.scale = this.minScale
    this.doubleClickZoomScale = options.doubleClickZoomScale

    this.isDoublePage = this.pageThumbnail2 !== undefined && this.pageThumbnail2 !== null ? true : false
    this.x = 0
    this.y = 0
    this.maxXValue = 0
    this.maxYValue = 0
    this.scaled = false
    this.enabled = true
    this._events = {}
    this.pixelRatio = window.devicePixelRatio || 1
    // this.isFitToWidth = false
    this.clickCount = 0

    this.addEvents()
  }

  setPageComponents (components) {
    this.minScale = this._toFixedNumber(components.minScale, 8)
    this.maxScale = components.maxScale
    this.pdfPage1 = components.pdfPage1
    this.pdfPage2 = components.pdfPage2
    this.pageFull1 = components.pageFull1
    this.pageFull2 = components.pageFull2
    this.textLayer1 = components.textLayer1
    this.textLayer2 = components.textLayer2
    this.scale = this.minScale
    this.doubleClickZoomScale = components.doubleClickZoomScale

    if (!this.eventsAdded) {
      this.addEvents()
    }
  }

  // clearPdfComponents () {
  //   this.pdfPage1 = undefined
  //   this.pdfPage2 = undefined
  //   this.pageFull1 = undefined
  //   this.pageFull2 = undefined
  //   this.textLayer1 = undefined
  //   this.textLayer2 = undefined
  // }

  setPdfPage1 (pdf) {
    this.pdfPage1 = pdf
  }

  setPdfPage2 (pdf) {
    this.pdfPage2 = pdf
  }

  setPageCanvas1 (canvas) {
    this.pageFull1 = canvas
  }

  setPageCanvas2 (canvas) {
    this.pageFull2 = canvas
  }

  setTextLayer1 (textLayer) {
    this.textLayer1 = textLayer
  }

  setTextLayer2 (textLayer) {
    this.textLayer2 = textLayer
  }

  setMinScale (scale) {
    this.minScale = this._toFixedNumber(scale, 8)
    this.scale = this.minScale
  }

  setMaxScale (scale) {
    this.maxScale = scale
  }

  reset () {
    this.x = 0
    this.y = 0
    this.maxXValue = 0
    this.maxYValue = 0
    this.scaled = false
  }

  hasPdfs () {
    return this.pdfPage1 !== undefined && this.pdfPage1 !== null
  }

  fitToWidth (ignoreMinScale) {
    const ignMinScale = ignoreMinScale !== undefined ? ignoreMinScale : false
    const scale = (Math.round(this.container.getBoundingClientRect().width) / Math.round(this.contentContainer.getBoundingClientRect().width)) * this.scale
    this.zoom(scale, undefined, 0, ignMinScale)
  }

  fitToHeight () {
    const scale = (Math.round(this.container.getBoundingClientRect().height) / Math.round(this.contentContainer.getBoundingClientRect().height)) * this.scale
    this.zoom(scale, undefined, undefined, true)
  }

  zoomToMinScale () {
    if (this.scale !== this.minScale) {
      this.zoom()
    }
    // scroll to top
    this.scrollTo(this.x, 0)
  }

  scrollToLeft () {
    const zoomWrapperWidth = Math.round(this.zoomWrapper.getBoundingClientRect().width)
    const pagesWidth = Math.round(this.contentContainer.getBoundingClientRect().width)
    const containerWidth = Math.round(this.container.getBoundingClientRect().width)
    if (pagesWidth > containerWidth) {
      const x = (pagesWidth - zoomWrapperWidth) / 2
      this.scrollTo(x, this.y)
    }
  }

  scrollToRight () {
    const zoomWrapperWidth = Math.round(this.zoomWrapper.getBoundingClientRect().width)
    const pagesWidth = Math.round(this.contentContainer.getBoundingClientRect().width)
    const containerWidth = Math.round(this.container.getBoundingClientRect().width)
    if (pagesWidth > containerWidth) {
      const x = ((pagesWidth - zoomWrapperWidth) / 2) - (pagesWidth - containerWidth)
      this.scrollTo(x, this.y)
    }
  }

  isScrolledToLeft () {
    const pagesLeft = Math.round(this.contentContainer.getBoundingClientRect().left)
    const containerLeft = Math.round(this.container.getBoundingClientRect().left)
    return pagesLeft + 5 >= containerLeft
  }

  isScrolledToRight () {
    const pagesRight = Math.round(this.contentContainer.getBoundingClientRect().right)
    const containerRight = Math.round(this.container.getBoundingClientRect().right)
    return pagesRight - 5 <= containerRight
  }

  disable () {
    this.enabled = false
  }

  enable () {
    this.enabled = true
  }

  destroy () {
    this.removeEvents()
  }

  updateSizeOfThumbnails (relScale) {
    const pageThumb1Height = this.pageThumbnail1.getBoundingClientRect().height
    const pageThumb1Width = this.pageThumbnail1.getBoundingClientRect().width

    // update style height and width of thumbnails
    this.pageThumbnail1.style.height = pageThumb1Height * relScale + 'px'
    this.pageThumbnail1.style.width = pageThumb1Width * relScale + 'px'

    if (this.isDoublePage) {
      const pageThumb2Height = this.pageThumbnail2.getBoundingClientRect().height
      const pageThumb2Width = this.pageThumbnail2.getBoundingClientRect().width
      this.pageThumbnail2.style.height = pageThumb2Height * relScale + 'px'
      this.pageThumbnail2.style.width = pageThumb2Width * relScale + 'px'
    }
  }

  updateSizeOfPageBitmaps (relScale) {
    if (this.pageFull1 !== undefined && !this.hasPdfs()) {
      const pageBitmap1Height = this.pageFull1.getBoundingClientRect().height
      const pageBitmap1Width = this.pageFull1.getBoundingClientRect().width
      this.pageFull1.style.height = pageBitmap1Height * relScale + 'px'
      this.pageFull1.style.width = pageBitmap1Width * relScale + 'px'
      this.pageThumbnail1.style.height = pageBitmap1Height * relScale + 'px'
      this.pageThumbnail1.style.width = pageBitmap1Width * relScale + 'px'
      if (this.isDoublePage) {
        const pageBitmap2Height = this.pageFull2.getBoundingClientRect().height
        const pageBitmap2Width = this.pageFull2.getBoundingClientRect().width
        this.pageFull2.style.height = pageBitmap2Height * relScale + 'px'
        this.pageFull2.style.width = pageBitmap2Width * relScale + 'px'
        this.pageThumbnail2.style.height = pageBitmap2Height * relScale + 'px'
        this.pageThumbnail2.style.width = pageBitmap2Width * relScale + 'px'
      }
    }
  }

  updateSizeOfPagePdfs(scale) {
    // get view ports with new scale
    const viewport1 = this.pdfPage1.getViewport({
      scale: scale
    })
    const viewport1Width = Math.floor(viewport1.width)
    const viewport1Height = Math.floor(viewport1.height)

    let viewport2
    let viewport2Width
    let viewport2Height
    if (this.isDoublePage) {
      viewport2 = this.pdfPage2.getViewport({
        scale: scale
      })
      viewport2Width = Math.floor(viewport2.width)
      viewport2Height = Math.floor(viewport2.height)
    }

    // update style height and width of thumbnails
    this.pageThumbnail1.style.height = viewport1Height + 'px'
    this.pageThumbnail1.style.width = viewport1Width + 'px'

    if (this.isDoublePage) {
      this.pageThumbnail2.style.height = viewport2Height + 'px'
      this.pageThumbnail2.style.width = viewport2Width + 'px'
    }

    // update style height and width of canvas style
    this.pageFull1.style.height = viewport1Height + 'px'
    this.pageFull1.style.width = viewport1Width + 'px'

    if (this.isDoublePage) {
      // update style height and width of canvas style
      this.pageFull2.style.height = viewport2Height + 'px'
      this.pageFull2.style.width = viewport2Width + 'px'
    }

    if (this.textLayer1 !== null) {
      this.textLayer1.style.height = viewport1Height + 'px'
      this.textLayer1.style.width = viewport1Width + 'px'
    }

    if (this.isDoublePage && this.textLayer2 !== null) {
      this.textLayer2.style.height = viewport2Height + 'px'
      this.textLayer2.style.width = viewport2Width + 'px'
    }
  }

  adjustXToBounds(x) {
    // const containerLeft = Math.round(this.container.getBoundingClientRect().left)
    const containerRight = Math.round(this.container.getBoundingClientRect().right)
    // if (!this.isFitToWidth) {

    const zoomWrapperRight = Math.round(this.zoomWrapper.getBoundingClientRect().right) + x - this.x
    const diffX = zoomWrapperRight - containerRight
    if (diffX < 0) {
        // we are going to be off the grid... correct it
      x = x - diffX
    }
    if (x > 0) {
      x = 0
    }

    // }
    // else {
    //   const pageRight = Math.round(this.contentContainer.getBoundingClientRect().right) + x - this.x
    //   const pageLeft = Math.round(this.contentContainer.getBoundingClientRect().left) + x - this.x
    //   const diffXRight = pageRight - containerRight
    //   if (diffXRight < 0) {
    //     x = x - diffXRight
    //   }
    //   const diffXLeft = pageLeft - containerLeft
    //   if (diffXLeft > 0) {
    //     x = x - diffXLeft
    //   }
    // }
    return x
  }

  adjustYToBounds(y) {
    let zoomWrapperBottom = Math.round(this.zoomWrapper.getBoundingClientRect().bottom) + y - this.y
    let containerBottom = Math.round(this.container.getBoundingClientRect().bottom)
    let diffY = zoomWrapperBottom - containerBottom
    if (diffY < 0) {
      // we are going to be off the grid... correct it
      y = y - diffY
    }
    if (y > 0) {
      y = 0
    }
    return y
  }

  isLeftPageInView () {
    return this._isInViewport(this.pageThumbnail1) || this._isInViewport(this.pageFull1)
  }

  isRightPageInView () {
    return this.isDoublePage ? this._isInViewport(this.pageThumbnail2) || this._isInViewport(this.pageFull2) : false
  }

  _isInViewport (element) {
    if (element === undefined || element === null || this.container === undefined) {
      return false
    }
    const rect = element.getBoundingClientRect()
    const containerRect = this.container.getBoundingClientRect()
    return (
      rect.left < containerRect.right &&
      rect.right > containerRect.left
    )
  }

  zoom (scale, x, y, ignoreMinScale) {
    if (!this.enabled) {
      return
    }

    const ignMinScale = ignoreMinScale !== undefined ? ignoreMinScale : false

    if (!ignMinScale && (scale === undefined || scale < this.minScale)) {
      scale = this.minScale
    }
    if (scale > this.maxScale) {
      scale = this.maxScale
    }

    const relScale = scale / this.scale

    if (this.hasPdfs()) {
      this.updateSizeOfPagePdfs(scale)
    } else {
      this.updateSizeOfThumbnails(relScale)
      this.updateSizeOfPageBitmaps(relScale)
    }

    // console.log('rel scale ' + relScale)

    const widthDiff = (this.zoomWrapper.clientWidth * relScale) - this.zoomWrapper.clientWidth
    const heightDiff = (this.zoomWrapper.clientHeight * relScale) - this.zoomWrapper.clientHeight

    let xValue
    let yValue

    if (x === undefined) {
      const xCenterOffset = window.innerWidth - this.container.getBoundingClientRect().right - this.container.getBoundingClientRect().left
      x = (window.innerWidth / 2) - (xCenterOffset / 2)
    }

    if (y === undefined) {
      y = window.innerHeight / 2
    }

    // adjust x and y to the bounds of the zoom wrapper.
    xValue = x - this.zoomWrapper.getBoundingClientRect().left
    yValue = y - this.zoomWrapper.getBoundingClientRect().top
    // the relative x and y values
    xValue = xValue / this.zoomWrapper.clientWidth
    yValue = yValue / this.zoomWrapper.clientHeight
    // I don't know how to describe this...
    // How much bigger/smaller will the zoom wrapper be?
    // multiply with the relative x and y values to find the value of how much we need to adjust the new wrapper to focus on the point.
    xValue = -(widthDiff * xValue) + this.x
    yValue = -(heightDiff * yValue) + this.y

    const pagesWidth = this.pageFull1.getBoundingClientRect().width + (this.pageFull2 !== null ? this.pageFull2.getBoundingClientRect().width : 0)
    // const pagesHeight = this.pageFull1.getBoundingClientRect().height + this.pageFull2.getBoundingClientRect().height
    const pagesHeight = this.pageFull1.getBoundingClientRect().height

    const zoomWrapperWidth = this.container.getBoundingClientRect().width > pagesWidth ? this.container.getBoundingClientRect().width : this.zoomWrapper.getBoundingClientRect().width * relScale
    const zoomWrapperHeight = this.container.getBoundingClientRect().height > pagesHeight ? this.container.getBoundingClientRect().height : this.zoomWrapper.getBoundingClientRect().height * relScale

    this.zoomWrapper.style.height = zoomWrapperHeight + 'px'
    this.zoomWrapper.style.width = zoomWrapperWidth + 'px'

    xValue = this.adjustXToBounds(xValue)
    yValue = this.adjustYToBounds(yValue)

    // Lets show the thumbnail as a loading overlay
    // this.pageThumbnail1.style.visibility = 'visible'
    // if (this.isDoublePage) {
    //   this.pageThumbnail2.style.visibility = 'visible'
    // }

    this.scaled = this.scale !== scale ? true : false
    this.scale = this._toFixedNumber(scale, 8)

    if (this.scaled) {
      this._execEvent('didZoom')
      // if (this.scale > this.minScale) {
      //   this._execEvent('didZoom')
      // } else if (this.scale === this.minScale) {
      //   this._execEvent('didZoomToMinScale')
      // }
    }

    this.scrollTo(xValue, yValue)
  }

  zoomToElement (element) {
    const elementRect = element.getBoundingClientRect()
    const zoomWrapperRect = this.zoomWrapper.getBoundingClientRect()
    const containerRect = this.container.getBoundingClientRect()
    const scaleWidthZoom = (zoomWrapperRect.width / elementRect.width)
    const scaleHeightZoom = (zoomWrapperRect.height / elementRect.height)
    const expectedHeight = elementRect.height * scaleWidthZoom
    let scale, y, x
    if (expectedHeight > zoomWrapperRect.height) {
      // Part of the zoom area will be out of view. Use scale based on height
      scale = scaleHeightZoom
      x = (elementRect.left - containerRect.left) * scale
      y = (elementRect.top - containerRect.top) * scale
      // Off set the x value to center the area horizontally.
      const scaledWidth = elementRect.width * scale
      const widthDiff = zoomWrapperRect.width - scaledWidth
      x = x + (-widthDiff / 2)
    } else {
      // Part of the zoom area will be out of view. Use scale based on width
      scale = scaleWidthZoom
      x = (elementRect.left - containerRect.left) * scale
      y = (elementRect.top - containerRect.top) * scale
      // Off set the y value to center the area vertically.
      const scaledHeight = elementRect.height * scale
      const heightDiff = containerRect.height - scaledHeight
      y = y + (-heightDiff / 2)
    }

    x = -x
    y = -y

    scale = scale * this.scale
    if (scale === undefined || scale < this.minScale) {
      scale = this.minScale
    }
    if (scale > this.maxScale) {
      scale = this.maxScale
    }

    const relScale = scale / this.scale

    if (this.hasPdfs()) {
      this.updateSizeOfPagePdfs(scale)
    } else {
      this.updateSizeOfThumbnails(relScale)
      this.updateSizeOfPageBitmaps(relScale)
    }

    this.zoomWrapper.style.height = Math.round(this.zoomWrapper.getBoundingClientRect().height * relScale) + 'px'
    this.zoomWrapper.style.width = Math.round(this.zoomWrapper.getBoundingClientRect().width * relScale) + 'px'

    x = this.adjustXToBounds(x)
    y = this.adjustYToBounds(y)

    this.scaled = this.scale !== scale ? true : false
    this.scale = this._toFixedNumber(scale, 8)

    if (this.scaled) {
      this._execEvent('didZoom')
      // if (this.scale > this.minScale) {
      //   this._execEvent('didZoom')
      // } else if (this.scale === this.minScale) {
      //   this._execEvent('didZoomToMinScale')
      // }
    }

    this.scrollTo(x, y)
  }

  scrollTo (x, y) {
    const pagesLeft = Math.round(this.contentContainer.getBoundingClientRect().left)
    const pagesRight = Math.round(this.contentContainer.getBoundingClientRect().right)
    const pagesWidth = Math.round(this.contentContainer.getBoundingClientRect().width)
    const pagesHeight = Math.round(this.contentContainer.getBoundingClientRect().height)
    const pagesTop = Math.round(this.contentContainer.getBoundingClientRect().top)
    const pagesBottom = Math.round(this.contentContainer.getBoundingClientRect().bottom)

    const containerLeft = Math.round(this.container.getBoundingClientRect().left)
    const containerRight = Math.round(this.container.getBoundingClientRect().right)
    const containerWidth = Math.round(this.container.getBoundingClientRect().width)
    const containerHeight = Math.round(this.container.getBoundingClientRect().height)
    const containerTop = Math.round(this.container.getBoundingClientRect().top)
    const containerBottom = Math.round(this.container.getBoundingClientRect().bottom)

    const zoomWrapperWidth = Math.round(this.zoomWrapper.getBoundingClientRect().width)
    const zoomWrapperHeight = Math.round(this.zoomWrapper.getBoundingClientRect().height)

    // console.log('pages bounds - left: ' + pagesLeft + ', right: ' + pagesRight + ', top: ' + pagesTop + ', bottom: ' + pagesBottom + ', width: ' + pagesWidth + ', height: ' + pagesHeight)
    // console.log('container bounds - left: ' + containerLeft + ', right: ' + containerRight + ', top: ' + containerTop + ', bottom: ' + containerBottom + ', width: ' + containerWidth + ', height: ' + containerHeight)
    // console.log('zoom wrapper size - width: ' + zoomWrapperWidth + ', height: ' + zoomWrapperHeight)
    // console.log('is scale: ' + this.scaled)

    if (pagesWidth <= containerWidth && pagesLeft >= containerLeft && pagesRight <= containerRight && !this.scaled) {
      x = this.x
    }

    if (pagesHeight <= containerHeight && pagesTop >= containerTop && pagesBottom <= containerBottom && !this.scaled) {
      y = this.y
    }

    // console.log('y: ' + y)
    // console.log('x: ' + x)

    const scrollDirectionLeft = (x < this.x) ? true : x > this.x ? false : null
    const scrollDirectionDown = (y < this.y) ? true : y > this.y ? false : null

    // console.log('scroll direction vertical: ' + scrollDirectionDown ? 'down' : 'up')
    // console.log('scroll direction horizontal: ' + scrollDirectionLeft ? 'left' : 'right')

    if (pagesWidth >= containerWidth && !this.scaled && scrollDirectionLeft !== null) {
      if (!scrollDirectionLeft) {
        // set up boundary rules when scrolling right

        // If the page's left bound is visible - block scrolling to the right
        if (pagesLeft > containerLeft) {
          return
        }

        // if the page's left bound is not visible - don't allow the page's left bound to become > container left bound
        // first question is the new x going to position the page's left bound > container left bound ?
        const expectedLeft = pagesLeft + x - this.x
        if (expectedLeft > containerLeft) {
          // figure out what the x should be to place the page on the left bound of the container.
          const maxScrollX = (pagesWidth - zoomWrapperWidth) / 2
          x = maxScrollX
        }
      } else {
        // set up boundary rules when scrolling left

        // If the page's right bound is visible - block scrolling to the left
        if (pagesRight < containerRight) {
          return
        }

        // if the page's right bound is not visible - don't allow the page's right bound to become < container right bound
        // first question is the new x going to position the page's right bound < container right bound ?
        const expectedRight = pagesRight + x - this.x
        if (expectedRight < containerRight) {
          const maxScrollX = ((pagesWidth - zoomWrapperWidth) / 2) - (pagesWidth - containerWidth)
          x = maxScrollX
        }
      }
    }

    // for scolling up and down - similar to left and right scrolling boundaries...
    if (pagesHeight >= containerHeight && !this.scaled && scrollDirectionDown !== null) {
      if (!scrollDirectionDown) {
        if (pagesTop > containerTop) {
          return
        }

        const expectedTop = pagesTop + y - this.y
        if (expectedTop > containerTop) {
          const maxScrollY = (pagesHeight - zoomWrapperHeight) / 2
          y = maxScrollY
        }
      } else {
        if (pagesBottom < containerBottom) {
          return
        }

        const expectedBottom = pagesBottom + y - this.y
        if (expectedBottom < containerBottom) {
          const maxScrollY = ((pagesHeight - zoomWrapperHeight) / 2) - (pagesHeight - containerHeight)
          y = maxScrollY
        }
      }
    }

    this.zoomWrapper.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

    this.x = x
    this.y = y

    if (this.pageFull1 !== undefined) {
      if (this.isLeftPageInView()) {
        this.pageFull1.style.visibility = 'visible'
      } else {
        this.pageFull1.style.visibility = 'hidden'
      }
    }


    if (this.isDoublePage && this.pageFull2 !== undefined) {
      if (this.isRightPageInView()) {
        this.pageFull2.style.visibility = 'visible'
      } else {
        this.pageFull2.style.visibility = 'hidden'
      }
    }
  }

  _displayThumbnails () {
    if (!this.hasPdfs()) {
      return
    }
    this.pageThumbnail1.style.display = 'inline-block'
    if (this.pageFull1 !== undefined) {
      this.pageFull1.height = 0
      this.pageFull1.width = 0
      this.pageFull1.style.display = 'none'
    }
    if (this.isDoublePage) {
      this.pageThumbnail2.style.display = 'inline-block'
      if (this.pageFull2 !== undefined) {
        this.pageFull2.height = 0
        this.pageFull2.width = 0
        this.pageFull2.style.display = 'none'
      }
    }
  }

  addEvents () {
    window.addEventListener('touchstart', this, { passive: false }, false)
    window.addEventListener('pointerdown', this, { passive: false }, false)
    window.addEventListener('mousedown', this, { passive: false }, false)
    window.addEventListener('touchmove', this, { passive: false }, false)
    window.addEventListener('pointermove', this, { passive: false }, false)
    window.addEventListener('mousemove', this, { passive: false }, false)
    window.addEventListener('touchend', this, { passive: false }, false)
    window.addEventListener('pointerup', this, { passive: false }, false)
    window.addEventListener('mouseup', this, { passive: false }, false)
    window.addEventListener('touchcancel', this, { passive: false }, false)
    window.addEventListener('pointercancel', this, { passive: false }, false)
    window.addEventListener('mousecancel', this, { passive: false }, false)
    window.addEventListener('mouseout', this, { passive: false }, false)
    // this.addEvent('orientationchange')
    // this.addEvent('resize')
    //
    // this.addEvent('transitionend')
    // webkitTransitionEnd

    window.addEventListener('wheel', this, { passive: false }, false)
    window.addEventListener('keydown', this, { passive: false }, false)
    window.addEventListener('click', this, { passive: false }, false)
    this.eventsAdded = true
  }

  removeEvents () {
    window.removeEventListener('touchstart', this, false)
    window.removeEventListener('pointerdown', this, false)
    window.removeEventListener('mousedown', this, false)
    window.removeEventListener('touchmove', this, false)
    window.removeEventListener('pointermove', this, false)
    window.removeEventListener('mousemove', this, false)
    window.removeEventListener('touchend', this, false)
    window.removeEventListener('pointerup', this, false)
    window.removeEventListener('mouseup', this, false)
    window.removeEventListener('touchcancel', this, false)
    window.removeEventListener('pointercancel', this, false)
    window.removeEventListener('mousecancel', this, false)
    window.removeEventListener('mouseout', this, false)
    window.removeEventListener('wheel', this, false)
    window.removeEventListener('keydown', this, false)
    window.removeEventListener('click', this, false)
    this.eventsAdded = false
  }


  handleEvent (e) {
    switch (e.type) {
      case 'touchstart':
      case 'pointerdown':
      case 'mousedown':
        if (e.touches && e.touches.length > 1) {
          if (e.composedPath().indexOf(this.contentContainer) !== -1) {
            // the right place
            this._startTouchZoom(e)
          } else {
            e.preventDefault()
            e.stopImmediatePropagation()
          }

          return
        }

        if (e.composedPath().indexOf(this.contentContainer) !== -1) {
          this._startMove(e)
        }
        break
      case 'touchmove':
      case 'pointermove':
      case 'mousemove':
        if (e.touches && e.touches[1]) {
          if (e.composedPath().indexOf(this.contentContainer) !== -1) {
            // the right place
            this._touchZoom(e)
          } else {
            e.preventDefault()
            e.stopImmediatePropagation()
          }
          return
        }

        if (e.composedPath().indexOf(this.contentContainer) !== -1) {
          this._move(e)
        }
        break
      case 'touchend':
      case 'pointerup':
      case 'mouseup':
      case 'touchcancel':
      case 'pointercancel':
      case 'mousecancel':
      case 'mouseout':
        if (this.touchZoomEnabled) {
          // this._endTouchZoom(e)
          if (e.composedPath().indexOf(this.contentContainer) !== -1) {
            // the right place
            this._endTouchZoom(e)
          } else {
            e.preventDefault()
            e.stopImmediatePropagation()
          }
          return
        }
        if (e.composedPath().indexOf(this.contentContainer) !== -1) {
          this._endMove(e)
          if (e.type === 'touchend' && !this.moved && !this.scaleChanged && e.changedTouches.length < 2) {
            this._click(e)
          }
        }
        break
      case 'orientationchange':
      case 'resize':
        // this._resize()
        break
      case 'transitionend':
      case 'webkitTransitionEnd':
        // this._transitionEnd(e)
        break
      case 'wheel':
        this._wheel(e)
        break
      case 'keydown':
        this._key(e)
        break
      case 'click':
        if (e.composedPath().indexOf(this.contentContainer) !== -1) {
          this._click(e)
        }
        break
    }
  }

  _startMove (e) {
    if (this.touchZoomEnabled) {
      return
    }
    e.preventDefault()
    this.moveEnabled = true

    var point = e.touches ? e.touches[0] : e

    this.pointX = point.pageX
    this.pointY = point.pageY

    this.distX = 0
    this.distY = 0

    this.moved = false
  }

  _startTouchZoom (e) {
    e.preventDefault()
    this.touchZoomEnabled = true
    const c1 = Math.abs( e.touches[0].pageX - e.touches[1].pageX )
    const c2 = Math.abs( e.touches[0].pageY - e.touches[1].pageY )

    this.touchesDistanceStart = Math.sqrt(c1 * c1 + c2 * c2)
    this.startScale = this.scale
  }

  _move (e) {
    if (!this.moveEnabled || this.touchZoomEnabled) {
      return
    }
    e.preventDefault()

    var point		= e.touches ? e.touches[0] : e,
      deltaX		= point.pageX - this.pointX,
      deltaY		= point.pageY - this.pointY,
      timestamp	= new Date().getTime(),
      absDistX, absDistY

    this.pointX	= point.pageX
    this.pointY	= point.pageY

    this.distX		+= deltaX
    this.distY		+= deltaY

    absDistX		= Math.abs(this.distX)
    absDistY		= Math.abs(this.distY)

    // We need to move at least 10 pixels for the scrolling to initiate
    if ( (this.endTime === undefined || timestamp - this.endTime > 300) && (absDistX < 10 && absDistY < 10) ) {
      return
    }

    let newX = this.x + deltaX
    let newY = this.y + deltaY

    this.scaled = false

    if (!this.moved) {
      this._execEvent('scrollStart')
    }

    this.moved = true

    this.scrollTo(newX, newY)
  }

  _touchZoom (e) {
    if (!this.enabled) {
      return
    }
    if (!this.touchZoomEnabled) {
      return
    }
    e.preventDefault()

    // if (!this.hasPdfs()) {
    //   return
    // }

    var xPoint = Math.abs(e.touches[0].clientX + e.touches[1].clientX) / 2
    var yPoint = Math.abs(e.touches[0].clientY + e.touches[1].clientY) / 2

    const c1 = Math.abs( e.touches[0].pageX - e.touches[1].pageX )
    const c2 = Math.abs( e.touches[0].pageY - e.touches[1].pageY )
		const distance = Math.sqrt( c1 * c1 + c2 * c2 )
    const scale = 1 / this.touchesDistanceStart * distance * this.startScale

    if (scale !== this.startScale && scale < this.maxScale && scale > this.minScale) {
      // a zoom is gonna happen
      this.scaleChanged = true
      if (this.zoomWithThumbnails) {
        // on phone we want to use thumbail for zooming instead of the canvas to save memory.
        this._displayThumbnails()
      }
    }

    this.scaled = true
    this.zoom(scale, xPoint, yPoint)
  }

  _endMove (e) {
    if (!this.moveEnabled || this.touchZoomEnabled) {
      return
    }
    e.preventDefault()
    this.moveEnabled = false
    this.endTime = new Date().getTime()
    this._execEvent('scrollEnd')
  }

  _endTouchZoom (e) {
    if (!this.touchZoomEnabled) {
      return
    }
    this.touchZoomEnabled = false
    e.preventDefault()
    this.scaled = false

    let that = this
    clearTimeout(this.touchZoomTimeout)
    this.touchZoomTimeout = setTimeout(function() {
      // touch zooming ended... stop touching me!
      if (that.scaleChanged) {
        if (that.startScale > that.scale) {
          that._execEvent('touchZoomOut')
        } else {
          that._execEvent('touchZoomIn')
        }
      }
      that.scaleChanged = false
      that.touchZoomTimeout = undefined
    }, 300)
  }

  _wheel (e) {
    // if (!this.enabled) {
    //   console.log('not enabled')
    //   return
    // }
    if (e.composedPath().indexOf(this.contentContainer) !== -1) {
      e.preventDefault()
    }

    // if (!this.hasPdfs()) {
    //   return
    // }

    var wheelDeltaX, wheelDeltaY,
      newX, newY,
      that = this

    // if (this.wheelTimeout === undefined) {
    //   // scroll started...
    //   this.startScale = this.scale
    //   console.log('scroll start')
    //   this._execEvent('scrollStart')
    // }

    // clearTimeout(this.wheelTimeout)
    // this.wheelTimeout = setTimeout(function() {
    //   // scroll ended
    //   console.log('scroll end')
    //   that._execEvent('scrollEnd')
    //   that.wheelTimeout = undefined
    // }, 400)

    let mouseWheelSpeed = 20

    if ('deltaX' in e) {
      if (e.deltaMode === 1) {
        wheelDeltaX = -e.deltaX * mouseWheelSpeed
        wheelDeltaY = -e.deltaY * mouseWheelSpeed
      } else {
        wheelDeltaX = -e.deltaX
        wheelDeltaY = -e.deltaY
      }
    }

    newX = this.x + Math.round(wheelDeltaX)
    newY = this.y + Math.round(wheelDeltaY)

    if (e.ctrlKey) {
      if (!this.enabled) {
        return
      }
      if (e.composedPath().indexOf(this.contentContainer) === -1) {
        e.preventDefault()
        e.stopPropagation()
        return
      }

      // this is a trackpad zoom event
      // console.log('trackpad point: ' + e.pageX + ', ' + e.pageY)
      const scale = this.scale + wheelDeltaY / 10

      if (scale !== this.scale && scale < this.maxScale && scale > this.minScale) {
        // a zoom is gonna happen
        this.scaleChanged = true
        // if (this.zoomWithThumbnails) {
        //   // on phone we want to use thumbail for zooming instead of the canvas to save memory.
        //   this._displayThumbnails()
        // }
      }

      this.zoom(this.scale + wheelDeltaY / 10, e.pageX, e.pageY)

      clearTimeout(this.trackpadTimeout)
      this.trackpadTimeout = setTimeout(function() {
        // trackpad zooming ended...

        if (that.scaleChanged) {
          if (that.startScale >= that.scale && that.scale !== that.maxScale) {
            that._execEvent('trackpadZoomOut')
          } else {
            that._execEvent('trackpadZoomIn')
          }
        }
        that.scaleChanged = false
        that.trackpadTimeout = undefined
      }, 300)
    } else {
      // this is a trackpad or wheel scroll event - no zooming.
      this.scaled = false

      // Do not scroll the page if user is scrolling the left scrubber.
      const leftAlignScrubber = document.getElementById('left-scrubber-container')
      if (leftAlignScrubber !== null && e.composedPath().indexOf(leftAlignScrubber) !== -1) {
        return
      }

      this.scrollTo(newX, newY)
    }
  }

  _key (e) {
    let now = new Date().getTime()
    let prevTime = this.keyTime || 0
    let acceleration = 1
    let newY = 0

    this.keyAcceleration = now - prevTime < 200 ? Math.min(this.keyAcceleration + acceleration, 50) : 0

    switch ( e.keyCode ) {
      case 38:
        // up
        newY = this.y + (10 + this.keyAcceleration>>0)
        break
      case 40:
        // down
        newY = this.y - (10 + this.keyAcceleration>>0)
        break
      case 33:
        // page up
        newY = this.y + Math.round(this.container.getBoundingClientRect().height)
        break
      case 34:
        // page down
        newY = this.y - Math.round(this.container.getBoundingClientRect().height)
        break
      default:
        return
    }
    this.scaled = false
    this.scrollTo(this.x, newY)
    this.keyTime = now
  }

  _click (e) {
    if (this.clickCount === 0 && this.clickTimer) {
      /* This an event we created in sendClick, skip it here */
      return
    }
    if (++this.clickCount === 1) {
      this.lastClickTime = Date.now()
      e.preventDefault()
      e.stopPropagation()
      let targetId = e.target.id
      this.clickTimer = setTimeout(() => {
        this.clickCount = 0
        this._sendClick(targetId)
        this.clickTimer = null
      }, 300)
    } else if (this.clickCount === 2) {
      e.stopPropagation()
      clearTimeout(this.clickTimer)
      this.clickTimer = null
      this.clickCount = 0
      if (Date.now() - this.lastClickTime < 100) {
        // too fast to be human... This can happen when using touch pinch zoom.
        this.lastClickTime = null
        return
      }
      this._doubleClick(e)
    }
  }

  _doubleClick (e) {
    if (!this.enabled) {
      return
    }
    var yValue = e.clientY
    var xValue = e.clientX
    if (yValue === undefined && xValue === undefined) {
      yValue = e.changedTouches[0].clientY
      xValue = e.changedTouches[0].clientX
    }
    if (this.scale !== this.minScale) {
      this.zoom(this.minScale, xValue, yValue)
      this._execEvent('doubleClickZoomOut')
    } else {
      this.zoom(this.doubleClickZoomScale, xValue, yValue)
      this._execEvent('doubleClickZoomIn')
    }
  }

  _sendClick (targetId) {
    /* Captured click was not a doubleclick, send a new click event to old target */
    /* eslint-disable no-undef */
    var event = new MouseEvent('pageSingleClick', {
      view: window,
      bubbles: true,
      cancelable: true
    })

    /* eslint-enable no-undef */
    const el = document.getElementById(targetId)
    if (el !== null) {
      el.dispatchEvent(event)
    }
  }


  on (type, fn) {
    if ( !this._events[type] ) {
      this._events[type] = []
    }

    this._events[type].push(fn)
  }

  off (type, fn) {
		if ( !this._events[type] ) {
			return
		}

		var index = this._events[type].indexOf(fn)

		if ( index > -1 ) {
			this._events[type].splice(index, 1)
		}
	}

  _execEvent (type) {
		if ( !this._events[type] ) {
			return;
		}

		var i = 0,
			l = this._events[type].length;

		if ( !l ) {
			return;
		}

    for ( ; i < l; i++ ) {
      // try {
      this._events[type][i].apply(this, [].slice.call(arguments, 1))
      // }
      // catch (err) {
      //   console.log('From CciPageZoom.js')
      //   console.log(err)
      // }
		}
	}

   _toFixedNumber (num, digits, base) {
    var pow = Math.pow(base||10, digits)
    return Math.round(num*pow) / pow
  }
}
